import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProjectRepAssigned from '../../ProjectRepAssigned';
import ProjectFeedbacks from '../../ProjectFeedbacks';
import SharesTable from '../../SharesTable';
import { formatCurrency } from '../../../numberUtils';
import { putRequest } from '../../../requestUtils';
import NextSteps from '../NextSteps';

class ProjectSidebar extends Component {
  constructor(props) {
    super(props);

    this.handleAcceptRehireRequest = this.handleAcceptRehireRequest.bind(this);
    this.handleCloseProject = this.handleCloseProject.bind(this);
    this.handleUpdateNextSteps = this.handleUpdateNextSteps.bind(this);
  }

  async handleCloseProject(e) {
    const { project, csrfToken } = this.props;

    e.preventDefault();
    await putRequest(
      `/projects/${project.resource_id}/close`,
      { project: { resource_id: project.resource_id } },
      csrfToken,
    );
    window.location.reload();
  }

  async handleAcceptRehireRequest() {
    const { project, csrfToken } = this.props;

    await putRequest(
      `/projects/${project.resource_id}/accept_rehire_request`,
      { project: { resource_id: project.resource_id } },
      csrfToken,
    );
    window.location.reload();
  }

  async handleUpdateNextSteps(action, link) {
    const { csrfToken, projectResourceId } = this.props;

    const { data } = await putRequest(
      `/projects/${projectResourceId}/update_next_steps`,
      { action_clicked: action },
      csrfToken,
    );

    this.setState({ nextStepsData: data });

    if (action === 'scoping_call') {
      window.open(link, '_blank');
    } else {
      window.location.href = link;
    }
  }

  renderRate() {
    const { project, acceptedProposal } = this.props;

    if (project.employment_type === 'full_time') {
      if (!acceptedProposal.base_annual_pay) { return null; }
      return `${formatCurrency(acceptedProposal.base_annual_pay, 0)}/yr`;
    }
    if (!acceptedProposal.public_hourly_rate) { return null; }
    return `${formatCurrency(acceptedProposal.public_hourly_rate, 0)}/h`;
  }

  renderWorkCompletedReview() {
    const { project, review, acceptedProposal } = this.props;
    const consultantName = (acceptedProposal && acceptedProposal.consultant_name.split(' ')[0])
      || 'Candidate';
    const { company_link: companyLink } = project;

    return (
      <div className="project-review box-shadow-1">
        { review.persisted && !review.editable
          ? <h2 className="demibold mb-12">Project completed by:</h2>
          : [
            <h2 className="demibold mb-12">How was your experience?</h2>,
            <div className="body-text-2 mb-3">
              { `Tell us how working with ${consultantName} was for this specific project.` }
            </div>,
          ]}

        <div className="fs-hide body-text-1 demibold mb-6 consultant-name">
          <a href={acceptedProposal.consultant_url} target="_blank" rel="noreferrer">
            { consultantName }
          </a>
        </div>

        { acceptedProposal.public_hourly_rate > 0
          ? (
            <div className="body-text-2 hourly-rate mb-3">
              { this.renderRate() }
            </div>
          ) : ''}

        { review.persisted && !review.editable
          ? [
            <a
              onClick={() => this.handleUpdateNextSteps(
                'extend_contract_or_hire_again',
                `${acceptedProposal.consultant_url}/hire_again?company_resource_id=${companyLink.split('/').at(-1)}`,
              )}
              className="btn standard-button btn-primary rehire-btn mb-3 full-width"
              role="button"
              tabIndex={0}
            >
              Hire Again
            </a>,
            <a
              href={acceptedProposal.review_proposal_url}
              className="btn btn-secondary standard-button body-text-2 review-proposal-btn"
              target="_blank"
              rel="noreferrer"
            >
              View Proposal
            </a>,
          ] : ''}
        { review.persisted
          ? [
            <a
              href={review.url}
              className={'btn btn-primary standard-button body-text-2 '
                  + 'rate-and-review-btn view-review-btn mt-2'}
            >
              View Review
            </a>,
            <div className="muted-gray-text body-text-2 mt-2">
              Note: You can edit your review before
              {' '}
              {review.editable_deadline}
              .
              After that we will record and publish it.
            </div>,
          ]
          : [
            <a
              href={`/projects/${project.resource_id}/reviews/new`}
              className={'btn btn-primary standard-button body-text-2 '
              + 'rate-and-review-btn new-review-btn'}
            >
              Rate & Review
              {' '}
              {consultantName}
            </a>,
            <a
              onClick={() => this.handleUpdateNextSteps(
                'extend_contract_or_hire_again',
                acceptedProposal.consultant_url,
              )}
              className="btn standard-button btn-secondary rehire-btn mt-3 full-width"
              role="button"
              tabIndex={0}
            >
              Hire Again
            </a>,
          ]}
      </div>
    );
  }

  renderProposalCta() {
    const {
      project, acceptedProposal, authUserCanSeeProposal, showHourlyRate,
      proposalCtaExplanationForEmployer, showHireAgain,
    } = this.props;
    const { company_link: companyLink } = project;
    const matchingOrRequestedMatching = project.status === 'clora_matching'
      || project.status === 'employer_requested_matching';

    if (!authUserCanSeeProposal || !(!matchingOrRequestedMatching
      || proposalCtaExplanationForEmployer || acceptedProposal)
    ) return null;

    return (
      <div className="count-header employer-proposal no-top-border box-shadow-1 mt-2">
        <h2 className="demibold mb-2">
          { matchingOrRequestedMatching
            ? ''
            : (
              <span>
                { project.proposal_cta_for_employer }
                <i className="ms-2 fas fa-star" />
              </span>
            )}
        </h2>
        <div className="body-text-2 regular">
          { proposalCtaExplanationForEmployer }
        </div>
        { acceptedProposal
          ? (
            <div className="accepted-proposal mt-4">
              <div className={`fs-hide body-text-1 demibold ${showHourlyRate ? 'mb-3' : 'mb-3'} consultant-name`}>
                <a href={acceptedProposal.consultant_url} target="_blank" rel="noreferrer" className=" ps-0">
                  { acceptedProposal.consultant_name }
                </a>
                { showHourlyRate
                  ? (
                    <div className="body-text-2 hourly-rate mb-4">
                      { this.renderRate() }
                    </div>
                  ) : <div className="mb-3" />}
                { showHireAgain
                  ? (
                    <a
                      onClick={() => this.handleUpdateNextSteps(
                        'extend_contract_or_hire_again',
                        `${acceptedProposal.consultant_url}/hire_again?company_resource_id=${companyLink.split('/').at(-1)}`,
                      )}
                      className="btn standard-button btn-primary rehire-btn full-width"
                      role="button"
                      tabIndex={0}
                    >
                      Hire Again
                    </a>
                  ) : ''}
                <a
                  href={acceptedProposal.review_proposal_url}
                  className={`btn standard-button ${showHireAgain ? 'btn-secondary' : 'btn-primary'} view-profile-btn full-width mt-2 mb-4`}
                  target="_blank"
                  rel="noreferrer"
                >
                  View Proposal
                </a>
              </div>
            </div>
          ) : ''}
      </div>
    );
  }

  renderProjectFeedback() {
    const {
      project, userType, invitedColleagues, invitedFeedback, projectPermissionLevel,
      colleagues, csrfToken, currentUserEmail,
    } = this.props;
    const draftOrRequestedMatching = project.status === 'employer_draft'
      || project.status === 'employer_requested_matching';

    if ((userType === 'rep' || !draftOrRequestedMatching) && project.feedbacks.length) {
      return (
        <ProjectFeedbacks
          canComment={false}
          canInvite={project.can_invite}
          feedbacks={project.feedbacks}
          resource="project"
          invitedColleagues={invitedColleagues}
          ownerEmail={project.owner_email}
          ownerName={project.owner}
        />
      );
    }

    if (projectPermissionLevel !== 'invoice_approver' && draftOrRequestedMatching) {
      return (
        <ProjectFeedbacks
          canComment
          canInvite={project.can_invite}
          feedback={invitedFeedback}
          feedbacks={project.feedbacks}
          invitedColleagues={invitedColleagues}
          colleagues={colleagues}
          csrfToken={csrfToken}
          resource="project"
          resourceId={project.resource_id}
          inviteUrl={`/projects/${project.resource_id}/project_feedbacks/invite`}
          emailShareUrl={`/projects/${project.resource_id}/project_feedbacks/reminder`}
          email={currentUserEmail}
          confirmEmailUrl="/confirmation/resend"
          ownerEmail={project.owner_email}
          ownerName={project.owner}
        />
      );
    }
    return (!(userType === 'rep' || projectPermissionLevel) ? this.renderStartProject() : '');
  }

  render() {
    const {
      project, userType, projectPermissionLevel, csrfToken, reps, shareOptions,
      shareRecipientOptions, salesBookingLink, invitationsCount, clickTab,
      initialTeamMembers, editableRoles, basePermissionsUrl, invitableRoles,
      nextStepsData, googleOmniauthUrl, msOmniauthUrl, signInUrl, inviterId,
      projectResourceId,
    } = this.props;

    return (
      <div className="g-flex-4 right-side project-actions-column">
        { !['closed', 'work_completed'].includes(nextStepsData.project_status)
          && (
          <NextSteps
            nextStepsData={nextStepsData}
            clickTab={clickTab}
            csrfToken={csrfToken}
            initialTeamMembers={initialTeamMembers}
            editableRoles={editableRoles}
            basePermissionsUrl={basePermissionsUrl}
            invitableRoles={invitableRoles}
            salesBookingLink={salesBookingLink}
            googleOmniauthUrl={googleOmniauthUrl}
            msOmniauthUrl={msOmniauthUrl}
            signInUrl={signInUrl}
            projectResourceId={projectResourceId}
            inviterId={inviterId}
          />
          )}
        { userType && userType === 'rep' ? [
          <div className="pb-4 project-proposals-flex-container">
            <ProjectRepAssigned
              reps={reps}
              assignedRep={project.assigned_rep}
              csrfToken={csrfToken}
              project={project}
            />
          </div>,
          <div className="bg-white p-0 project-proposals-flex-container">
            <SharesTable
              triggerType="button"
              csrfToken={csrfToken}
              project={project}
              shareOptions={shareOptions}
              recipientOptions={shareRecipientOptions}
            />
          </div>] : ''}

        { project.status === 'employer_requested_matching' && userType === 'employer'
          ? (
            <div className="schedule-call box-shadow-1 white-container mb-2">
              <h2 className="bold">
                Schedule a call
                <i className="fas fa-calendar" />
              </h2>
              <p className="body-text-2 mt-2 mb-3 subtext">
                Meet with a Clora rep to complete your project.
              </p>
              <p className="booking-button center">
                <a
                  onClick={() => this.handleUpdateNextSteps('scoping_call', salesBookingLink)}
                  className="btn btn-primary"
                  role="button"
                  tabIndex={0}
                >
                  Schedule a Call
                </a>
              </p>
            </div>
          ) : ''}
        { project.status === 'work_completed' && projectPermissionLevel === 'owner'
          ? this.renderWorkCompletedReview()
          : project.status !== 'employer_draft' && this.renderProposalCta() }
        { userType === 'rep' && invitationsCount
          ? (
            <div className={'project-sent-invitations-container'
          + ' white-container box-shadow-1 mb-3'}
            >
              <div className="body-text-1 demibold">
                <a
                  href={`/projects/${project.resource_id}/project_invitations`}
                  id="invitations-count"
                  className="btn btn-secondary-no-border"
                >
                  <span className="invitations">
                    <i className="fa fa-user-plus me-2" />
                    Invitations
                  </span>
                  <span className="invitations-count">
                    { invitationsCount }
                    <i className="fa fa-angle-right ms-3" />
                  </span>
                </a>
              </div>
            </div>
          ) : ''}
        { project.status === 'closed'
          ? (
            <div className="white-container project-info-box box-shadow-1 mb-3">
              <h2>Project Closed</h2>
              { project.is_request && project.rehire_consultant
                ? (
                  <div className="mt-2 body-text-2">
                    <a href={`users/${project.rehire_consultant.resource_id}`}>
                      { project.rehire_consultant.name }
                    </a>
                    , who you requested to work with, is not available.
                    Clora will help you to find the right candidate for your need.
                  </div>
                ) : ''}
            </div>
          ) : ''}

        {userType === 'rep'
          && project.rehire_consultant
          && project.status === 'employer_requested_matching' && (
          <div className="white-container rehire-request-rep-actions project-info-box box-shadow-1  mb-3 ">
            <h2 className="demibold mb-12">Rehire request pending</h2>
            <div className="body-text-2 regular">
              {project.rehire_request_creator.name || project.owner_display}
              {' '}
              requested to rehire
              {' '}
              {project.rehire_consultant.name}
              {' '}
              for this project.
              Check availability with the candidate to move on.
            </div>

            <div className="accepted-proposal mt-4">
              <div className="fs-hide body-text-1 medium-weight mb-3 consultant-name">
                <a href={`/users/${project.rehire_consultant.resource_id}`}>
                  {project.rehire_consultant.name}
                </a>
              </div>
              <a
                role="link"
                tabIndex={0}
                onClick={this.handleAcceptRehireRequest}
                className="btn standard-button btn-primary mb-2 full-width"
              >
                Accept Request
              </a>
              <a
                role="link"
                tabIndex={0}
                onClick={this.handleCloseProject}
                className="btn standard-button btn-secondary mb-3 full-width"
              >
                Close Request
              </a>
            </div>
          </div>
        )}

        { userType && (projectPermissionLevel || userType === 'rep' || project.feedbacks.length)
          ? this.renderProjectFeedback() : '' }
      </div>
    );
  }
}

ProjectSidebar.propTypes = {
  project: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  userType: PropTypes.string,
  projectPermissionLevel: PropTypes.string,
  reps: PropTypes.arrayOf(PropTypes.shape({})),
  shareOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  shareRecipientOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  salesBookingLink: PropTypes.string,
  invitationsCount: PropTypes.number,
  invitedColleagues: PropTypes.arrayOf(PropTypes.shape({})),
  invitedFeedback: PropTypes.shape({}),
  colleagues: PropTypes.arrayOf(PropTypes.shape({})),
  currentUserEmail: PropTypes.string,
  authUserCanSeeProposal: PropTypes.bool,
  review: PropTypes.shape({}),
  proposalCtaExplanationForEmployer: PropTypes.string,
  acceptedProposal: PropTypes.shape({}),
  showHourlyRate: PropTypes.bool,
  showHireAgain: PropTypes.bool,
  nextStepsData: PropTypes.shape({}),
  clickTab: PropTypes.func,
  initialTeamMembers: PropTypes.shape({}),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  editableRoles: PropTypes.arrayOf(PropTypes.string),
  basePermissionsUrl: PropTypes.string.isRequired,
  projectResourceId: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  inviterId: PropTypes.string,
};

ProjectSidebar.defaultProps = {
  userType: null,
  projectPermissionLevel: null,
  reps: [],
  salesBookingLink: null,
  invitationsCount: 0,
  invitedColleagues: [],
  invitedFeedback: null,
  colleagues: [],
  currentUserEmail: '',
  authUserCanSeeProposal: false,
  review: null,
  proposalCtaExplanationForEmployer: null,
  acceptedProposal: null,
  showHourlyRate: false,
  showHireAgain: false,
  nextStepsData: {},
  clickTab: () => {},
  initialTeamMembers: {},
  invitableRoles: [],
  editableRoles: [],
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  inviterId: null,
};

export default ProjectSidebar;
